module.exports = __webpack_public_path__ + "img/Find a driver.7b4579d3.svg";